import { getProperty, getType } from '@ozgene/gp5.utils.object-functions';

/**
 *
 * @param {String} objectKey String referring to a property within the a and b objects
 * @param {Object} a Object containing a property with the same name as the objectKey value
 * @param {Object} b Object containing a property with the same name as the objectKey value
 * @returns {Function} SortByString function
 */
export const getSortByStringProperty = (objectKey) => (a, b) =>
  sortByString(getProperty(a, objectKey), getProperty(b, objectKey));

/**
 *
 *@param {String} objectKey String referring to a property within the a and b objects
 * @param {Object} a Object containing a property with the same name as the objectKey value
 * @param {Object} b Object containing a property with the same name as the objectKey value
 * @returns {Function} SortByNumber function
 */
export const getSortByNumberProperty = (objectKey) => (a, b) =>
  sortByNumber(getProperty(a, objectKey), getProperty(b, objectKey));

/**
 *
 * @param {String} objectKey String referring to a property within the a and b objects
 * @param {Object} a Object containing a property with the same name as the objectKey value
 * @param {Object} b Object containing a property with the same name as the objectKey value
 * @returns {Function} SortByDate function
 */
export const getSortByDateProperty = (objectKey) => (a, b) =>
  sortByDate(getProperty(a, objectKey), getProperty(b, objectKey));

/**
 *
 * @param {String} a First string value
 * @param {String} b Second string value
 * @returns {Number|Error} Number to determine sort order of strings
 */
export const sortByString = (a, b) => {
  try {
    return new Intl.Collator('en', {
      sensitivity: 'base',
      ignorePunctuation: true,
    }).compare(a, b);
  } catch (e) {
    throw new Error(`sortByString: Inconsistent parameter types`);
  }
};

/**
 *
 * @param {Number} a First number value
 * @param {Number} b Secod number value
 * @returns {Number|Error} Number to determine sort order of numbers, error for mismatched types
 */
export const sortByNumber = (a, b) => {
  try {
    return Number(a) - Number(b);
  } catch (e) {
    throw new Error(`sortByNumber: Inconsistent parameter types`);
  }
};

/**
 *
 * @param {Date} a First date value
 * @param {Date} b Second date value
 * @returns {Number|Error} number to determine sort order fo dates, error for mismatched types
 */
export const sortByDate = (a, b) => {
  try {
    return a - b;
  } catch (e) {
    throw new Error(`sortByDate: Inconsistent parameter types`);
  }
};

/**
 *
 * @param {Function} getValue Function to extract value from object for comparison
 * @returns {Function} Comparator function that can be used with Array.sort()
 */
export const sortByProperty = (getValue) => (a, b) => {
  const aValue = getValue(a);
  const bValue = getValue(b);
  const aType = getType(aValue);
  const bType = getType(bValue);

  if (aType === 'string' && bType === 'string') {
    return sortByString(aValue, bValue);
  } else if (aType === 'number' && bType === 'number') {
    return sortByNumber(aValue, bValue);
  } else if (aType === 'date' && bType === 'date') {
    return sortByDate(aValue, bValue);
  } else {
    // Fallback to string comparison
    return sortByString(String(aValue), String(bValue));
  }
};
